import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import SuccessModal from "../SuccessModal";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import {
  getStoreByWarehouseInfo,
  getWarehouseGarmentsByStatus,
  postSendToStore,
  toGenerateChallanFromWarehouse,
} from "../../services/warehouse/WarehouseProcess";
import ConfirmStoreChange from "./ConfirmStoreChange";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

const { innerWidth: width, innerHeight: height } = window;

const WarehouseOrderStatusReportDone = () => {
  const navigate = useNavigate();
  const { warehouseData } = getUserData();

  const location = useLocation();
  const { data, storeId } = location.state || {}; // Fallback to prevent undefined errors

  let warehouseId = warehouseData.id;
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedQrCodes, setSelectedQrCodes] = useState([]);
  const [selectedQrCodesChecked, setSelectedQrCodesChecked] = useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isSendButtonPressed, setIsSendButtonPressed] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  const [dataProvider, setDataProvider] = useState([]);

  const [selectedRows, setSelectedRows] = useState([]);

  const [confirmStoreChangeModalVisible, setConfirmStoreChangeModalVisible] =
    useState(false);

  const fetchData = (requestData) => {
    getWarehouseGarmentsByStatus(warehouseId, requestData)
      .then((response) => {
        if (response.data.error) return;

        const uniqueGarments = Array.from(
          new Map(
            response.data.map((item) => [
              item.qrCode,
              {
                qrCode: item.qrCode,
                garmentName: item.garmentName,
                id: item.id,
              },
            ]),
          ).values(),
        );

        const filteredGarments = uniqueGarments.filter((item) =>
          item.qrCode?.toLowerCase().startsWith(searchTerm.toLowerCase()),
        );

        setSelectedQrCodes(filteredGarments);
        setDataProvider(filteredGarments);
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const receiveDataFromConfirmModal = ({ success }) => {
    if (success) {
      setSelectedQrCodes([]);
      setSelectedQrCodesChecked([]);
      setSearchTerm("");
    }
  };

  const handleOrderSelection = (e) => {
    setSelectedRows(e.value);
    const selected = e.value?.map((item) => item.invoiceNo) || [];

    const data = {
      status: ["READY_TO_SEND_TO_STORE_BY_WARE_HOUSE"],
      storeWareHouseIds: [storeId],
      invoiceNoIn: selected,
    };
    fetchData(data);
  };

  const handleSendToStore = () => {
    // Check if the button has already been pressed
    if (!isSendButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsSendButtonPressed(true);
      toGenerateChallanFromWarehouse(storeId)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            const data = {
              qrCodeInfoList: selectedQrCodes.map((item) => ({
                id: item.id,
              })),
              wareHouseStoreChallanDTO: response.data,
            };
            postSendToStore(warehouseId, data)
              .then((response) => {
                if (!response.data.error) {
                  const Res = response.data;
                  const message = Res.message;
                  const success = Res.status;
                  if (success === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setIsSendButtonPressed(false);
                    setTimeout(() => {
                      navigate("/");
                    }, 1500);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsSendButtonPressed(false);
                  }
                }
              })
              .catch((err) => {
                console.error("Error:", err);
              });
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  const rowRenderer = () => {
    return dataProvider?.map((item, index) => (
      <div
        key={index}
        className="flex flex-row py-1 mx-2 justify-content-between"
      >
        <p className="flex-1 text-lg font-normal ">{item.qrCode}</p>
        <p className="flex-1 text-lg font-normal ">
          {(item.garmentName.replace(/_/g, " ") + "").substring(0, 20)}
          {(item.garmentName + "").length > 20 ? "..." : ""}
        </p>
      </div>
    ));
  };

  const invoiceBodyTemplate = (rowData) => {
    return (
      <div className="cursor-pointer">
        <span>{rowData?.invoiceNo}</span>
      </div>
    );
  };

  const RenderTabView = (data) => {
    // Get all unique statuses from all orders
    const statusColumns = [
      ...new Set(
        data?.flatMap((item) =>
          item?.orderStatusList?.map((statusItem) => statusItem.status),
        ),
      ),
    ];

    return (
      <DataTable
        showGridlines
        value={data}
        paginator
        rows={100}
        rowsPerPageOptions={[50, 100]}
        stripedRows
        scrollable
        scrollHeight={height - 280}
        selectionMode="checkbox"
        selection={selectedRows}
        onSelectionChange={handleOrderSelection}
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) => options.rowIndex + 1}
        />
        <Column
          selectionMode="multiple"
          //  header="Select All"
          style={{ width: "50px" }}
        ></Column>
        <Column
          field="invoiceNo"
          header="Invoice No"
          style={{
            width: "120px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={invoiceBodyTemplate}
        />

        <Column field="count" header="Total Garment" />

        {statusColumns.map((status) => (
          <Column
            key={status}
            header={status
              .replace(/_/g, " ")
              .replace("SENT TO WARE HOUSE", "RECEIVED")}
            style={{ minWidth: "180px" }}
            body={(rowData) => {
              const statusData = rowData?.orderStatusList?.find(
                (item) => item.status === status,
              );

              return <span>{statusData?.count ?? 0}</span>;
            }}
          />
        ))}
      </DataTable>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/WarehouseOrderStatusReport")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Order Status Done Report
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-1 ">
        <div className="flex-1">
          <div className=" flex-1">
            {data.length > 0 ? (
              <>
                <div className="scroll-bar mb-2 mt-4">
                  <div className="mx-4 report-table">
                    <div className="tab-view-table">{RenderTabView(data)}</div>
                  </div>
                </div>
              </>
            ) : data.length === 0 ? (
              <div className="flex-1 flex flex-column justify-content-center align-items-center">
                <p className="text-3xl font-Bold">No Tag Found</p>
              </div>
            ) : (
              <div className="flex-1 flex flex-column justify-content-center align-items-center">
                <p className="text-3xl font-Bold">Tag List is Loading</p>
              </div>
            )}
            <div>
              <div className="flex-1">
                <div className="flex-1">
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <p className="w-full text-3xl  font-bold text-start">
                      Garments Tag List
                    </p>
                  </div>
                </div>

                {selectedQrCodes.length === 0 ? (
                  <div>
                    <p className=" text-3xl  font-bold text-center">
                      Please Select Tag
                    </p>
                  </div>
                ) : (
                  <div>
                    <div className="flex flex-row py-1 mx-2 justify-content-between">
                      <p className="flex-1 text-2xl font-medium ">Tag</p>
                      <p className="flex-1 text-2xl font-medium">Garment</p>
                    </div>
                    <div>
                      <div style={{ overflowY: "auto", height: "45vh" }}>
                        {rowRenderer()}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <ConfirmStoreChange
                setConfirmStoreChangeModalVisible={
                  setConfirmStoreChangeModalVisible
                }
                confirmStoreChangeModalVisible={confirmStoreChangeModalVisible}
                sendDataToConfirmStoreChange={receiveDataFromConfirmModal}
              />
              <SuccessModal
                setModalVisible={setModalVisible}
                modalVisible={modalVisible}
                status={modalStatus}
                text={modalText}
              />
            </div>
            {selectedQrCodes.length > 0 && (
              <div
                className="my-1 mx-2"
                style={{
                  pointerEvents: isSendButtonPressed ? "none" : "auto",
                }}
              >
                <div className="flex-1 mx-2 mb-1 mt-2 sticky z-2 bottom-0">
                  <div className=" flex justify-content-center">
                    <Button
                      onClick={handleSendToStore}
                      disabled={isSendButtonPressed}
                      className="flex justify-content-center text-2xl w-full border-round-xl border-none cursor-pointer"
                    >
                      <p className="text-xl font-bold text-white text-center">
                        {isSendButtonPressed ? "Sending..." : "Send"}
                      </p>

                      <div className="flex justify-content-center ml-5 relative">
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                          }
                          style={{ width: 30 }}
                        />
                        <div
                          style={{
                            left: 28,
                            position: "absolute",
                            top: -10,
                            backgroundColor: "red",
                            borderRadius: 20,
                            minWidth: 36,
                            height: 36,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <p className=" text-md  font-normal text-center">
                            {selectedQrCodes.length}
                          </p>
                        </div>
                      </div>
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WarehouseOrderStatusReportDone;
